import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  scheduledPromotionRaffles: [],
  scheduledPromotionRaffle: null,
};

export default {
  namespaced: true,
  name: "scheduledPromotionRaffles",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_SCHEDULED_PROMOTION_RAFFLES](state, payload = []) {
      state.scheduledPromotionRaffle = payload;
    },
    [actions.GET_SCHEDULED_PROMOTION_RAFFLE](state, payload = null) {
      state.scheduledPromotionRaffle = payload;
    },
    [actions.CREATE_SCHEDULED_PROMOTION_RAFFLE](state, payload = null) {
      state.scheduledPromotionRaffle = payload;
    },
    [actions.UPDATE_SCHEDULED_PROMOTION_RAFFLE](state, payload = null) {
      state.scheduledPromotionRaffle = payload;
    },
    [actions.RESET_SCHEDULED_PROMOTION_RAFFLE_FORM](state) {
      state.scheduledPromotionRaffle = null;
    },
  },
  actions: {
    async fetchScheduledPromotionRaffles({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.scheduledPromotionRaffles.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_SCHEDULED_PROMOTION_RAFFLES, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_SCHEDULED_PROMOTION_RAFFLES, []);
          reject(error);
        }
      });
    },
    async fetchScheduledPromotionRaffleTickets(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { raffleId, ...rest } = payload;
          const response = await restClient(
            path.admin.scheduledPromotionRaffles.tickets(raffleId),
            "GET",
            null,
            rest
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async fetchScheduledPromotionRaffle({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.scheduledPromotionRaffles.single(payload),
            "GET"
          );
          commit(actions.GET_SCHEDULED_PROMOTION_RAFFLE, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_SCHEDULED_PROMOTION_RAFFLE, null);
          reject(error);
        }
      });
    },
    async createScheduledPromotionRaffle({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.scheduledPromotionRaffles.base,
            "POST",
            payload
          );
          commit(actions.CREATE_SCHEDULED_PROMOTION_RAFFLE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async updateScheduledPromotionRaffle({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.scheduledPromotionRaffles.single(payload.id),
            "PUT",
            payload
          );
          commit(actions.UPDATE_SCHEDULED_PROMOTION_RAFFLE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_SCHEDULED_PROMOTION_RAFFLE_FORM);
    },
  },
};
